(ns hai.home.mobile
  "Mobile body for the home route. Reuses calendar/tasks events+subs from
   the desktop body; the shared shell (header/drawer/FAB) is supplied by
   [[hai.web-app.mobile/mobile-chrome]]. Which cards show is the platform's
   call, through [[hai.mini-apps.data]]; the order is this body's."
  (:require
   [hai.home.mobile.mini-apps.calendar :as calendar]
   [hai.home.mobile.mini-apps.notes :as notes]
   [hai.home.mobile.mini-apps.progress :as progress]
   [hai.home.mobile.mini-apps.tasks :as tasks]
   [hai.home.mobile.mini-apps.tips-and-tricks :as tips-and-tricks]
   [hai.mini-apps.data :as mini-apps]
   [hai.ui.rf-sugar :refer [<s]]))

(defn- slot
  [panel mini-app]
  (when mini-app
    [panel mini-app]))

(defn body []
  (let [mini-apps @(<s [::mini-apps/by-tool])]
    [:<>
     [slot tips-and-tricks/panel (:tips-and-tricks mini-apps)]
     [slot notes/panel (:notes mini-apps)]
     [slot tasks/panel (:tasks mini-apps)]
     [slot calendar/panel (:calendar mini-apps)]
     [slot progress/panel (:progress mini-apps)]]))
